<template>
    <div id="new-instagram-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper d-none">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>

                <InstagramPageSelector
                    :pages="callbackResponse.pages"
                    v-model="selectedPage"
                    v-if="callbackResponse.accessToken"
                />

                <div v-else class="connect-body">
                    <div class="requirements">
                        <div>
                            <i class="material-icons">info</i>
                            {{ $t("message.instaAddDesc1") }}
                        </div>
                        <div><i class="material-icons">info</i>{{ $t("message.instaAddDesc2") }}</div>
                        <div><i class="material-icons">info</i>{{ $t("message.instaAddDesc3") }}</div>
                        <div><i class="material-icons">info</i>{{ $t("message.instaAddDesc4") }}</div>
                    </div>

                    <strong> {{ $t("message.instaAddDesc5") }} </strong>

                    <div>
                        <a-checkbox :checked="termOfService" @change="acceptTermOfService('pp')"></a-checkbox>
                        <b
                        >{{ $t("search.integration.readAndAgree") }}
                            <a @click="acceptTermOfService('pp')">{{ $t("search.integration.privatePolicy") }}</a>
                            {{ $t("message.and") }}
                            <a @click="acceptTermOfService('tac')">{{
                                    $t("search.integration.termsAndCondition")
                                }}</a></b
                        >
                    </div>
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <SupsisButton ghost @click="handleCancel"> {{ $t("wp.cancel") }}</SupsisButton>
                <SupsisButton
                    primary
                    @click="handleSubmit"
                    :disabled="!termOfService || loading || !!callbackResponse.accessToken"
                >
                    {{ $t("message.connectToInsta") }}
                </SupsisButton>
            </div>
        </div>
        <TermOfService
            v-if="termOfServiceModal"
            :type="termOfServiceModal"
            @agree="acceptedTermOfService"
            @cancel="termOfServiceModal = null"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import CONFIG from "../../../../config/config";
import { copyText2Clipboard } from "../../../../utils/utils";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { first, map, timeout } from "rxjs/operators";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import InstagramPageSelector from "./InstagramPageSelector.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import TermOfService from "../../../../components/TermOfService.vue";
import { generateRandomId } from "../../../../utils/session";

export default {
    name: "CreateInstagramChannel",
    props: {
        channel: {
            type: Object,
            default: () => {
            },
        },
    },
    components: {
        TermOfService,
        Modal2,
        InstagramPageSelector,
        SupsisButton,
    },
    data() {
        return {
            form: {
                channelName: "Ideasoft",
                domain: "",
                clientId: "",
                clientSecret: "",
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
            callbackResponse: {
                accessToken: null,
                pages: [],
            },
            selectedPage: null,
            termOfService: false,
            termOfServiceModal: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
            userId: (state) => state.auth.user?._id || state.auth.adminUser?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        acceptTermOfService(type) {
            this.termOfServiceModal = type || "pp";
        },
        acceptedTermOfService() {
            this.termOfServiceModal = null;
            this.termOfService = true;
        },
        getRedirectURL() {
            return `${CONFIG.SOCKET_URL}/webhook/oauth2/facebook`;
        },
        copyWebhookAddress() {
            copyText2Clipboard(this.getRedirectURL());
            this.$message.success("Redirect URL  copied to clipboard");
        },
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        startOauth() {
            const isMetaReviewer = this.siteId === "66226622d71532c33bea346e";
            const FACEBOOK_APP_ID = "7174288719300175";
            this.loading = true;
            const redirectUrl = this.getRedirectURL();

            const scopes = [
                "ads_management",
                "business_management",
                "instagram_basic",
                "instagram_manage_comments",
                "instagram_manage_messages",
                "pages_manage_ads",
                "pages_manage_engagement",
                "pages_manage_metadata",
                "pages_messaging",
                "pages_read_engagement",
                "pages_read_user_content",
                "pages_show_list",
                "public_profile",
                "pages_manage_ads"
            ];
            const scope = scopes.join(",");
            const state = this.siteId + "_" + this.userId + "_instagram_" + generateRandomId(4);
            const url = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${redirectUrl}&state=${state}&scope=${scope}`;
            this.listenSocket();
            this.window = window.open(url, "_blank");
        },
        listenSocket() {
            socketMessageStream
                .pipe(
                    first((x) => x.cmd === "facebook_callback_response"),
                    map((x) => x.data),
                    timeout(60000 * 10),
                )
                .toPromise()
                .then(async (data) => {
                    this.loading = false;
                    this.window.close();
                    this.$message.success("Instagram connected successfully");
                    this.callbackResponse = data.tokenInfo;
                })
                .catch((err) => {
                    this.loading = false;
                    this.window.close();
                    this.$message.error("Failed to connect Instagram");
                });
        },
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "instagram",
                name: _.get(
                    this.selectedPage,
                    "instagram_business_account.name",
                    _.get(this.selectedPage, "instagram_business_account.username", "Instagram User"),
                ),
            };
            return this.createChannel(data)
                .then((channel) => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                    sendSocketMessage("meta subscribe-webhook", {
                        siteId: this.siteId,
                        channelId: channel._id,
                    });
                })
                .catch((err) => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    this.startOauth();
                }
            }
        },
    },
    mounted() {
    },
    beforeDestroy() {
    },
    watch: {
        selectedPage: {
            handler: async function(page) {
                if (page) {
                    const payload = {
                        page,
                        type: "instagram",
                        id: page.instagram_business_account.id,
                        oauth: this.callbackResponse,
                    };
                    await this.completeCreateChannel(payload);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#new-instagram-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .webhook-info {
            display: flex;
            gap: 5px;
            justify-content: center;
            padding: 5px;
            overflow-wrap: anywhere;

            .anticon {
                &:hover {
                    color: var(--color-text-info-hover);
                }
            }
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 75px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);

        .actions {
            display: flex;
            gap: 10px;
        }
    }

    .connect-body {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: center;

        .requirements {
            display: flex;
            flex-direction: column;
            gap: 5px;

            div {
                display: flex;
                gap: 5px;
                align-items: center;
                justify-content: flex-start;

                .material-icons {
                    color: var(--color-text-info-default);
                    font-size: 13px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
